module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-cantainer"
  }, [_c('div', {
    staticClass: "product-main"
  }, [_c('div', {
    staticClass: "product-img"
  }, [_c('div', {
    staticClass: "prod-img-top"
  }, [_c('div', {
    staticClass: "show-img"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('el-image', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgList[_vm.nowIndex] == _vm.nowImg),
      expression: "imgList[nowIndex]==nowImg"
    }],
    key: _vm.nowIndex,
    staticClass: "goodImg",
    staticStyle: {
      "height": "90%"
    },
    attrs: {
      "src": _vm.nowImg,
      "preview-src-list": _vm.imgList
    }
  })], 1)], 1), _vm._v(" "), (_vm.imgList.length > 1) ? _c('div', {
    staticClass: "img-list"
  }, _vm._l((_vm.imgList), function(item, index) {
    return _c('img', {
      key: index,
      style: (_vm.nowIndex == index ? 'border:1px solid #1077FF' : ''),
      attrs: {
        "src": item
      },
      on: {
        "click": function($event) {
          return _vm.switchImg(index)
        },
        "mouseover": function($event) {
          return _vm.switchImg(index)
        }
      }
    })
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "product-details"
  }, [_c('div', {
    staticClass: "prod-title-box"
  }, [_c('p', {
    staticClass: "prod-title"
  }, [_vm._v(_vm._s(_vm.msg.title))])]), _vm._v(" "), _c('div', {
    staticClass: "prod-info"
  }, [_c('div', {
    staticClass: "prod-info-price"
  }, [_vm._v("\n          售价"), _c('span', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_vm._v("-")]), _vm._v("￥" + _vm._s(_vm.msg.price) + "\n        ")]), _vm._v(" "), _vm._l((_vm.product.spu), function(val, i) {
    return _c('div', {
      staticClass: "prod-info-detail"
    }, [_c('p', {
      staticClass: "model-title"
    }, [_vm._v(_vm._s(val.name))]), _vm._v(" "), _c('div', {
      staticClass: "prod-info-model"
    }, _vm._l((val.item), function(item, index) {
      return _c('div', {
        staticClass: "info-model"
      }, [_c('div', {
        key: index,
        staticClass: "model-item",
        style: (_vm.lableNum == index ? 'border:1px solid #007AFF;' : ''),
        on: {
          "click": function($event) {
            return _vm.switchGoods(index, item.name)
          }
        },
        model: {
          value: (_vm.lableNum),
          callback: function($$v) {
            _vm.lableNum = $$v
          },
          expression: "lableNum"
        }
      }, [_vm._v(_vm._s(item.name))])])
    }), 0)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "statistics"
  }, [_c('span', [_vm._v("数量选择")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "margin-left": "50px",
      "width": "130px"
    },
    attrs: {
      "min": 1,
      "max": 999
    },
    model: {
      value: (_vm.productNum),
      callback: function($$v) {
        _vm.productNum = $$v
      },
      expression: "productNum"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#8d9ba8"
    }
  }, [_vm._v("\n        有货\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "prod-total"
  }, [_vm._l((_vm.product.spu), function(val, i) {
    return _c('span', {
      staticClass: "prod-total-txt"
    }, [_vm._v(_vm._s(val.name) + " "), _c('span', {
      staticClass: "total-txt"
    }, [_vm._v(_vm._s(_vm.lableName))]), _vm._v(" ，"), _c('span', {
      staticClass: "total-txt"
    }, [_vm._v(_vm._s(_vm.productNum))]), _vm._v(" 件商品")])
  }), _vm._v("\n         "), _c('span', [_vm._v(" 合计  ￥"), _c('span', {
    staticClass: "total-txt"
  }, [_vm._v(_vm._s(_vm.msg.price * _vm.productNum))]), _vm._v(" 元")])], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px white solid",
      "margin-top": "20px",
      "width": "100%",
      "height": "15%"
    }
  }, [_c('el-button', {
    staticClass: "myBtn",
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("立即购买")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "prod-show"
  }, [_c('p', {
    staticClass: "prod-show-title"
  }, [_vm._v("商品详情")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "600",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.msg.title))]), _vm._v(" "), _vm._l((_vm.product.spu), function(val, i) {
    return _c('div', {
      staticStyle: {
        "width": "100%",
        "height": "60px",
        "margin-top": "20px",
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "border": "1px solid #F3F6F8"
      }
    }, [_c('div', {
      staticClass: "tableTr"
    }, [_vm._v(_vm._s(val.name))]), _vm._v(" "), _c('div', {
      staticClass: "tableTd"
    }, [_c('p', _vm._l((val.item), function(item, index) {
      return _c('span', [(index) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(_vm._s(item.name))])
    }), 0)])])])
  }), _vm._v(" "), _vm._m(0)], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogFlag,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFlag = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/qr/qrcode.jpg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("扫码进入"), _c('span', {
    staticStyle: {
      "color": "#007aff"
    }
  }, [_vm._v("医小智Mall")]), _vm._v("小程序下单")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prod-info-list"
  }, [_c('ul')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c1a1caa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Mall/productDetails.vue
// module id = 645
// module chunks = 0